var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDoubleGate(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "background"), /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    id: "canvas_background",
    height: 18,
    width: 18,
    y: -1,
    x: -1
  }), /*#__PURE__*/React.createElement("g", {
    display: "none",
    overflow: "visible",
    y: 0,
    x: 0,
    height: "100%",
    width: "100%",
    id: "canvasGrid"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "url(#gridpattern)",
    strokeWidth: 0,
    y: 0,
    x: 0,
    height: "100%",
    width: "100%"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("rect", {
    stroke: "#000",
    id: "svg_3",
    height: 13.030892,
    width: 10.476076,
    y: 1.252097,
    x: 2.808454,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("line", {
    strokeLinecap: "null",
    strokeLinejoin: "null",
    id: "svg_4",
    y2: 14.91173,
    x2: 0.421893,
    y1: 0.747333,
    x1: 0.483881,
    fillOpacity: "null",
    strokeOpacity: "null",
    stroke: "#000",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    stroke: "#000",
    strokeLinecap: "null",
    strokeLinejoin: "null",
    id: "svg_5",
    y2: 14.880736,
    x2: 15.485125,
    y1: 0.716339,
    x1: 15.547113,
    fillOpacity: "null",
    strokeOpacity: "null",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    strokeLinecap: "null",
    strokeLinejoin: "null",
    id: "svg_7",
    y2: 2.575997,
    x2: 2.715471,
    y1: 2.575997,
    x1: 0.76283,
    fillOpacity: "null",
    strokeOpacity: "null",
    stroke: "#000",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    strokeLinecap: "null",
    strokeLinejoin: "null",
    id: "svg_8",
    y2: 12.46318,
    x2: 2.653482,
    y1: 12.46318,
    x1: 0.700841,
    fillOpacity: "null",
    strokeOpacity: "null",
    stroke: "#000",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    strokeLinecap: "null",
    strokeLinejoin: "null",
    id: "svg_9",
    y2: 12.432186,
    x2: 15.516119,
    y1: 12.432186,
    x1: 13.563478,
    fillOpacity: "null",
    strokeOpacity: "null",
    stroke: "#000",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    strokeLinecap: "null",
    strokeLinejoin: "null",
    id: "svg_10",
    y2: 2.514008,
    x2: 15.144187,
    y1: 2.514008,
    x1: 13.191546,
    fillOpacity: "null",
    strokeOpacity: "null",
    stroke: "#000",
    fill: "none"
  }), /*#__PURE__*/React.createElement("text", {
    stroke: "#000",
    transform: "matrix(0.5431849984918585,0,0,0.5431849984918585,0.3695599441554498,-5.666184736003031) ",
    xmlSpace: "preserve",
    textAnchor: "start",
    fontFamily: "Helvetica, Arial, sans-serif",
    fontSize: 24,
    id: "svg_13",
    y: 32.966447,
    x: 5.627695,
    fillOpacity: "null",
    strokeOpacity: "null",
    strokeWidth: 0,
    fill: "#000000"
  }, "D"))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleGate);
export default __webpack_public_path__ + "static/media/double_gate.aed8bb3563662392ed465fa194f0174b.svg";
export { ForwardRef as ReactComponent };